import React from "react";
import { useTranslation } from 'react-i18next';
import Contact from "../Components/contact/Contact";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import seoData from "../data/seoData.json";

function ContactPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = seoData[currentLang]?.contact || seoData.en.contact;

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/iletisim"
      />
      <TopBar />
      <Spacer/><Spacer />
      <Contact />
    </>
  );
}

export default ContactPage;
